export default __webpack_public_path__ + "static/media/W2GIF-1.c58c1026.gif";